import axios from 'axios';
import BaseAPI from './base/base-api';

class MisaIdAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'misaid';
}

export default new MisaIdAPI();